import { ApplicationRootState } from 'types';
import { Product } from 'types/schema';
import { ActionType } from 'typesafe-actions';
import * as actions from './actions';

export interface ISection {
  [k: string]: ISectionData;
}

export interface KamereoFreshState {
  readonly loading: boolean;
  readonly sections: ISection;
  readonly loadingNote: boolean;
}

type KamereoFreshActions = ActionType<typeof actions>;

export const CommonDimensions = {
  MAX_WIDTH_CONTAINER: 1272,
};

export enum KamereoFreshSectionEnum {
  Fruit = 'KAMEREO_FRESH_FRUIT',
  ReadyToEat = 'KAMEREO_FRESH_READY_TO_EAT',
  FreshIngredients = 'KAMEREO_FRESH_INGREDIENTS',
}

export interface ISectionData {
  id: KamereoFreshSectionEnum;
  title: string;
  categoryIds: number[];
  banner: string;
  data: Product[];
  error: boolean;
  fetching?: boolean;
  totalResults: number;
  loading?: boolean;
}

export interface KamereoFreshScreenState {
  readonly sections: ISection;
}

export type RootState = ApplicationRootState;
export type ContainerState = KamereoFreshState;
export type ContainerActions = KamereoFreshActions;
